import type { LucideIcon } from 'lucide-react'

import { cn } from '@/core/lib/utils'
import { Card, CardContent } from '@/ui/card'

export interface SalesSummaryCard {
  id: string
  label: string
  value: string
  icon: LucideIcon
  color: string
  sub?: string
}

interface SalesSummaryCardsProps {
  cards: SalesSummaryCard[]
  className?: string
}

export function SalesSummaryCards({ cards, className }: SalesSummaryCardsProps) {
  return (
    <div className={cn('grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4', className)}>
      {cards.map(({ id, label, value, icon: Icon, color, sub }) => {
        const parts = color.split(' ')
        const textColor = parts.find((c) => c.startsWith('text-')) ?? ''
        const bgColor = parts.find((c) => c.startsWith('bg-')) ?? ''
        return (
          <Card key={id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4 md:p-5">
              <div className="flex items-start justify-between mb-3">
                <p className="text-xs md:text-sm text-slate-500 font-medium leading-snug">{label}</p>
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ml-2 ${bgColor}`}>
                  <Icon className={`w-5 h-5 ${textColor}`} />
                </div>
              </div>
              <p className="text-2xl md:text-3xl font-bold text-navy">{value}</p>
              {sub && <p className="text-xs text-slate-500 mt-2">{sub}</p>}
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}
